function formatState(state) {
  var data = JSON.parse($(state.element).attr('data') || '{}')
  if (!state.id) {
    return state.text;
  }
  var $state = $(`
    <div class="list-item" data-id="${state.id}">
      <div class="item-img">
        <img src="${data.avatar || '/images/default_avatar.png'}" alt="">
      </div>
      <div class="item-text">
        <span>${data.first_name || ''} ${data.last_name || ''}</span>
      </div>
      <span class="btn-container">
        <button type="button" class="checkbox-btn"></button>
      </span>
    </div>
  `);
  return $state;
};

function cloneList(elem) {
  var selected_list = $(elem).next().find('.select2-selection__rendered').hide();
  var clone = selected_list.clone(true, true).show();
  if ($(elem).val() && $(elem).val().length) {
    clone.prepend(`      
      <li class="select2-selection__choice">
        <button type="button" class="select2-selection__choice__remove" tabindex="-1">
          <span aria-hidden="true">×</span>
        </button>
        <span class="select2-selection__choice__display">Clear All</span>
      </li>
    `)
    clone.find('.select2-selection__choice:first').on('click', function () {
      setTimeout(function () {
        $(elem).val([]).trigger('change')
      }, 0);
    })
  }
  clone.find('.select2-selection__choice').on('click', function () {
    var id = $(this).find('[data-id]').attr('data-id');
    console.log(id);
    setTimeout(function () {
      $(elem).val($(elem).val().filter(el => el != id)).trigger('change');
    }, 0)
  })
  $('.selected2').empty().append(clone)
}


$('.select2-search').on('keydown', function (e) {
  if (e.which === 8 && !e.target.value.length) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

global.modules.set({
  async init(context) {
    $('.select_agent', context).select2({
      templateResult: formatState,
      templateSelection: function (data) {
        return $(`<span data-id=${data?.id}>${data.text}</span>`);
      },
      closeOnSelect: false,
      multiple: true,
      dropdownParent: $('.place-dropdown'),
      "language": {
        "noResults": function () {
          return $(`
            <div class="list-item">
              <div class="item-text">
                <span>No agents found</span>
              </div>
            </div>
          `);
        }
      }
    }).on('change', function () {
      cloneList($(this));
    })
    cloneList($('.select_agent', context));
  }
})
